window.addEventListener("DOMContentLoaded", () => {
    let AjaxCol = new NewAjaxCollection();
    AjaxCol.init();
});
class NewAjaxCollection {
    constructor() { }
    init() {
        let sortBy = document.querySelectorAll(".nav-sortby a")
        let partial_filter = document.querySelectorAll("#sl-modal-collection-filter .filter-menu .partial_filter a");
        let full_filter = document.querySelectorAll("#sl-modal-collection-filter .filter-menu .full_filter a");
        let clearButton = document.querySelectorAll("#sl-modal-collection-filter .clear-all-filters a");
        let quickLinksColletions = document.querySelectorAll(
            ".js-collection-filter a"
        );
        let apply = document.querySelector(".apply-changes span");
        let loadMoreButton = document.querySelector(".collection_load_more")
        let inputs = document.querySelectorAll(".cc-price-range__input");
        // if (!apply) {
        //     return;
        // }
        // apply.addEventListener("click", () => {
        //     document.querySelector(".overlay-mobile-filters").style.display = "none";
        // });
        const links = [
            ...sortBy,
            ...full_filter,
            ...partial_filter,
            ...quickLinksColletions,
            ...clearButton,
            ...(loadMoreButton ? [loadMoreButton] : [])
        ];
        let isPartFinder = document.querySelector(".sp-collection-part-finder");
        links.forEach((link) => {
            link.addEventListener("click", (e) => { 
                e.preventDefault();
                const isLoadMore = link.classList.contains("collection_load_more");
                if (link.classList.contains("filter-clear")) {
                } else {
                    if (!link.classList.contains("a-sortby")) {
                        link.parentNode.parentNode.classList.toggle("selected");
                    }
                }
                if (!isLoadMore && !link.href.includes("?discount")) {
                    if (history.state != null && history.state.parameter) {
                        link.href = link.href + `?discount=${history.state.parameter}`;
                    }
                }
                if (isPartFinder) {
                    isPartFinder.classList.add('loading');
                    params.set('view', 'part-finder')
                    const url = new URL(link.href);
                    const params = url.searchParams;
                    this.fetchData(url.href);
                } else if (isLoadMore) {
                    const url = new URL(link.href);
                    const params = url.searchParams;
                    params.delete('discount')
                    if (link.href.indexOf("view=") != -1) {
                        params.delete('view')
                    }
                    // if (link.href.indexOf("view=ajax") !== -1) {
                    //     params.delete('view')
                    // }
                    params.delete('discount')
                    params.set('section_id', 'sl-collection')
                    this.fetchData(url.href);
                } else {
                    if (link.classList.contains('collection-link')) {
                        const closest_ul = link.closest('ul');
                        if (closest_ul.classList.contains('partial_filter')) {
                            const url = new URL(link.href);
                            const params = url.searchParams;
                            if (link.href.indexOf("view=") != -1) {
                                params.delete('view')
                            }
                            params.set('section_id', 'sl-collection')
                            this.fetchData(url.href, 'replace');
                        } else {
                            this.fetchData(link.href, 'full');
                        }
                    } else {
                        this.fetchData(link.href, 'full');
                    }
                }
            })
        })
        inputs.forEach((singleInput) => {
            singleInput.addEventListener('change', debounce((event) => {
                event.preventDefault();
                var queryVals = [];
                let parentElementNode = event.target.parentNode.parentNode;
                parentElementNode.querySelectorAll('input').forEach((inputElement) => {
                    if (inputElement.value !== '') {
                        queryVals.push([inputElement.name, encodeURIComponent(inputElement.value)]);
                    }
                })
                var newUrl = new URLSearchParams(location.search);
                queryVals.forEach(function (value) {
                    newUrl.set(value[0], value[1])
                });
                newUrl.set('section_id', 'sl-collection')
                this.fetchData(location.pathname + '?' + newUrl.toString(), "replace");
            }), 500)
        })
        document.querySelector(".current-filters")?.addEventListener("click", (e) => {
            const btn = e.target.closest(".tag-remove");
            if (!btn) return;

            const tag = btn.getAttribute("data-tag");
            const target = document.querySelector(`.filter-active-${tag} a`);
            if (target) target.click();
        });
    }

    fetchData(link, type = "short") {
        let container = document.querySelector(".sl-collection")
        container.classList.add("loading");
        let storeurl = new URL(link, window.location.origin);
        link = storeurl.toString()
        fetch(link)
            .then((response) => response.text())
            .then((responseText) => { 
                link = link.replace('&section_id=sl-collection', '')
                link = link.replace('?section_id=sl-collection', '')
                const html = responseText;
                const parser = new DOMParser();
                let newDOM = parser.parseFromString(html, "text/html");
                // const queryString = window.location.search;
                // const urlParams = new URLSearchParams(queryString);
                // let par = urlParams.get("discount");
                // urlParams.delete("section_id");
                // let stateObj = { parameter: par };
                // window.history.replaceState(stateObj, null, link);
                let storeurl = new URL(link, window.location.origin);
                let currentParams = new URLSearchParams(window.location.search);
                let par = currentParams.get('discount')
                let stateObj = { parameter: par }
                if (document.querySelector(".sp-collection-banner")) {
                    storeurl.searchParams.set('view', 'new-collection');
                }
                if (currentParams.has('discount')) {
                    storeurl.searchParams.set('discount', currentParams.get('discount'));
                }
                // Update the browser's URL without reloading
                window.history.replaceState(stateObj, '', storeurl.toString());
                if (type == 'full') {
                    this.updateCollectionGrid(newDOM, link);
                } else {
                    this.updateProdutGrid(newDOM, link, type);
                }
                this.reloadJS(type);
            })
    }

    updateCollectionGrid(newDOM, link, type = 'full') {
        let current = {
            grid: document.querySelector("#sl-collection__items"),
            current_filters: document.querySelector(".current-filters"),
            sortby: document.querySelector(".nav-sortby-top"),
            pagination: document.querySelector(".js-pagination-list-collection"),
            title: document.querySelector(".js-collection-title"),
            count: document.querySelector(".js-showing-products"),
            count_mobile: document.querySelector(
                ".js-showing-products-mobile"
            ),
            sideBar: document.querySelector(
                "#sl-modal-collection-filter .overlay-mobile-filters .filter-menu"
            ),
            description: document.querySelector(".js-collection-description"),
            collections: document.querySelector(
                ".js-collection-filter.collections"
            ),
            breadcrumbs: document.querySelector(".sl-breadcrumb"),
            collectionImage: document.querySelector(".sp-collection-banner__media-img"),
            slconcernSection: document.querySelector(".sl-concern-section .sl-container"),
            faq: document.querySelector(".home-sleep-faqs"),
            bestSeller: document.querySelector(".js-best-selling"),
            blog: document.querySelector(".blog-list-collection"),
            // reviews: document.querySelector(".carousel-section__wrapper"),
            // videos: document.querySelector(".collection-video-section")
        };
        let news = {
            grid: newDOM.querySelector("#sl-collection__items"),
            current_filters: newDOM.querySelector(".current-filters"),
            sortby: newDOM.querySelector(".nav-sortby-top"),
            pagination: newDOM.querySelector(".js-pagination-list-collection"),
            title: newDOM.querySelector(".js-collection-title"),
            count: newDOM.querySelector(".js-showing-products"),
            count_mobile: newDOM.querySelector(
                ".js-showing-products-mobile"
            ),
            sideBar: newDOM.querySelector(
                "#sl-modal-collection-filter .overlay-mobile-filters .filter-menu"
            ),
            description: newDOM.querySelector(".js-collection-description"),
            collections: newDOM.querySelector(
                ".js-collection-filter.collections"
            ),
            breadcrumbs: newDOM.querySelector(".sl-breadcrumb"),
            collectionImage: newDOM.querySelector(".sp-collection-banner__media-img"),
            slconcernSection: newDOM.querySelector(".sl-concern-section .sl-container"),
            faq: newDOM.querySelector(".home-sleep-faqs"),
            bestSeller: newDOM.querySelector(".js-best-selling"),
            blog: newDOM.querySelector(".blog-list-collection"),
            // reviews: newDOM.querySelector(".carousel-section__wrapper"),
            // videos: newDOM.querySelector(".collection-video-section")
        };
        if(!news.grid) {
            return;
        }
        current.grid.innerHTML = news.grid.innerHTML;
        current.current_filters.innerHTML = news.current_filters.innerHTML;
        let open_filters = [];
        current.sideBar
            .querySelectorAll(".filter-group.pt-filter-mode-replacer")
            .forEach((fg) => {
                if (fg.classList.contains("open")) {
                    open_filters.push(fg);
                }
            });
        current.sideBar.innerHTML = news.sideBar.innerHTML;
        current.sideBar
            .querySelectorAll(".filter-group.pt-filter-mode-replacer")
            .forEach((fg) => {
                open_filters.forEach((of) => {
                    const currentTitle = fg.querySelector(".filter-group__title")?.innerHTML;
                    const oldTitle = of.querySelector(".filter-group__title")?.innerHTML;

                    if (currentTitle === oldTitle) {
                        fg.classList.add("open");
                    }
                });
            });
        current.count.innerHTML = news.count.innerHTML;
        current.title.innerHTML = news.title.innerHTML;
        current.breadcrumbs.innerHTML = news.breadcrumbs.innerHTML;
        current.collections.innerHTML = news.collections.innerHTML;
        current.description.innerHTML = news.description.innerHTML;
        current.pagination.innerHTML = news.pagination.innerHTML;
        current.faq.innerHTML = news.faq.innerHTML;
        current.blog.innerHTML = news.blog.innerHTML;
        if (current.collectionImage) {
            current.collectionImage.innerHTML = news.collectionImage.innerHTML;
        }
        if (news.slconcernSection) {
            if (current.slconcernSection) {
                if ($('.js-sl-concern-slider').length > 0 && $('.js-sl-concern-slider').hasClass('slick-initialized')) {
                    $('.js-sl-concern-slider').slick('unslick');
                    current.slconcernSection.innerHTML = '';
                    current.slconcernSection.innerHTML = news.slconcernSection.innerHTML;
                    $('.js-sl-concern-slider').slick({
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 4,
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 575,
                                settings: {
                                    slidesToShow: 1.65
                                }
                            }
                        ]
                    });
                }
            } else {
            }
        } else {
            if (current.slconcernSection) {
                if ($('.js-sl-concern-slider').length > 0 && $('.js-sl-concern-slider').hasClass('slick-initialized')) {
                    $('.js-sl-concern-slider').slick('unslick');
                    current.slconcernSection.innerHTML = '';
                    current.slconcernSection.classList.remove('slick-initialized')
                }
            }
        }
        if (current.bestSeller) {
            if ($('.js-sp-colle-best-sell-slider').length > 0 && $('.js-sp-colle-best-sell-slider').hasClass('slick-initialized')) {
                $('.js-sp-testimonial-slider').slick('unslick');
                current.bestSeller.innerHTML = '';
                current.bestSeller.classList.remove('slick-initialized')
                current.bestSeller.innerHTML = news.bestSeller.innerHTML;
                if ($('.js-sp-colle-best-sell-slider').length > 0 && !$('.js-sp-colle-best-sell-slider').hasClass('slick-initialized') && !news.collectionImage.classList.contains('slick-initialized')) {
                    $('.js-sp-colle-best-sell-slider').slick({
                        slidesToShow: 3.6,
                        slidesToScroll: 1,
                        dots: false,
                        infinite: false,
                        prevArrow: $('.sp-arrow .prev-arrow'),
                        nextArrow: $('.sp-arrow .next-arrow'),
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 2.1
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 1.5
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1.4,
                                    arrows: false
                                }
                            }
                        ]
                    });
                }
            }
        }
        // if (link.split("collections/")[1] === "all") {
        //     document.querySelector(".filter-menu").classList.add("is-all");
        //     document
        //         .querySelector(".filter-group.filter-group-all-collections .js-summary")
        //         .classList.add("active");
        // } else {
        //     document.querySelector(".filter-menu").classList.remove("is-all");
        //     /* setTimeOut 500 */
        //     setTimeout(() => {
        //         document
        //             .querySelector(".filter-group.filter-group-all-collections .js-summary")
        //             .classList.remove("active");
        //         document.querySelectorAll(".filter-group")[3].classList.add("open");
        //     }, 100);
        // }
        yotpoWidgetsContainer.initWidgets();
        this.init();
        let app_download_btn = document.querySelectorAll(".app_download_btn");
        if (app_download_btn.length > 0) {
            let devicePlatformtype = determinePlatform();
            let downloadlink = getDownloadLink(devicePlatformtype);
            app_download_btn.forEach(function (e, i) {
                e.href = downloadlink;
            })
        }
        let checkifData = document.querySelector(".js-collection-filter");
        let stickyWrapper = document.querySelector(".sl-collection__nav + .sl-collection__header");
        if (checkifData && checkifData?.innerHTML == '') {
            checkifData.parentElement.classList.add('d-none');
            stickyWrapper?.classList.add('nofilter')
        }
        // this.reloadJS(type);
    }

    updateProdutGrid(newDOM, link, type = 'short') {
        let section = document.querySelector("#sl-collection__items");
        const newGrid = newDOM.querySelector('#sl-collection__items');
        section.classList.remove("loading");
        let current = {
            current_filters: document.querySelector(".current-filters"),
            sideBar: document.querySelector(
                "#sl-modal-collection-filter .overlay-mobile-filters .filter-menu"
            )
        };
        let news = {
            current_filters: newDOM.querySelector(".current-filters"),
            sideBar: newDOM.querySelector(
                "#sl-modal-collection-filter .overlay-mobile-filters .filter-menu"
            )
        };

        if (type == 'replace') {
            section.innerHTML = newGrid.innerHTML;
            current.current_filters.innerHTML = news.current_filters.innerHTML;
            let open_filters = [];
            current.sideBar
                .querySelectorAll(".filter-group.pt-filter-mode-replacer")
                .forEach((fg) => {
                    if (fg.classList.contains("open")) {
                        open_filters.push(fg);
                    }
                });
            current.sideBar.innerHTML = news.sideBar.innerHTML;
            current.sideBar
                .querySelectorAll(".filter-group.pt-filter-mode-replacer")
                .forEach((fg) => {
                    open_filters.forEach((of) => {
                        const currentTitle = fg.querySelector(".filter-group__title")?.innerHTML;
                        const oldTitle = of.querySelector(".filter-group__title")?.innerHTML;

                        if (currentTitle === oldTitle) {
                            fg.classList.add("open");
                        }
                    });
                });
        } else {
            section.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }
        let paginationWrapper = newDOM.querySelector('.sl-collection__cta');
        // let previousPage = document.querySelector('.sl-collection__cta');
        let load_more_btn = document.querySelector(".sl-collection__cta");
        if (paginationWrapper.innerHTML.trim() != '') {
            if (paginationWrapper.querySelector('.productcount') && load_more_btn.querySelector('.productcount')) {
                load_more_btn.querySelector('.productcount').innerHTML = paginationWrapper.querySelector('.productcount').innerHTML;
            }
            let newLoadMorebtn = paginationWrapper.querySelector('.collection_load_more');
            if (newLoadMorebtn) {
                if (load_more_btn.querySelector('.collection_load_more')) {
                    load_more_btn.querySelector('.collection_load_more').href = newLoadMorebtn.href;
                } else {
                    load_more_btn.innerHTML = paginationWrapper.innerHTML
                }
            } else {
                load_more_btn.querySelector('.collection_load_more')?.remove();
            }
        } else {
            load_more_btn.querySelector('.collection_load_more')?.remove();
        }
        let number_of_products = document.querySelectorAll("[data-productcount]");
        let number_of_products_newdom = newDOM.querySelectorAll("[data-productcount]");
        if (type == 'replace') {
            if (number_of_products.length > 0) {
                number_of_products.forEach(function (element, index) {
                    if (number_of_products_newdom[index]) {
                        element.innerHTML = number_of_products_newdom[index].innerHTML
                    } else {
                        element.parentElement.style.display = 'none'
                    }
                })
            }
        } else {
            let base_count = number_of_products[0].innerHTML;
            number_of_products.forEach(function (element, index) {
                if (number_of_products_newdom) {
                    element.innerHTML = parseInt(base_count) + parseInt(number_of_products_newdom[0].dataset.count);
                }
            })
        }
        this.init();
        // this.reloadJS(type);
    }

    reloadJS(type) {
        document.dispatchEvent(
            new CustomEvent("ajaxSearchComplete", {
                bubbles: true,
                detail: {},
            }),
        );
        let container = document.querySelector(".sl-collection")
        container.classList.remove("loading");
        preventHyperLinking();
        if (type == 'full') {
            if ($(".js-sl-blogs-slider").length > 0) {
                $(".js-sl-blogs-slider").slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    infinite: false,
                    arrows: false,
                    lazyload: 'progressive',
                    autoplay: true,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1.15,
                                dots: true
                            }
                        }
                    ]
                });
            }
            const collapses = () => {
                const animatedElements = document.querySelectorAll('.fade-in-animation');
                animatedElements.forEach(element => {
                    element.classList.add('visible');
                });
                if ($(".js-sp-product-card-key-title").length > 0) {
                    $(".js-sp-product-card-key-title").click(function () {
                        $(this).toggleClass("is-active");
                        $(this).next('.js-sp-product-card-key-list').slideToggle();
                    })
                }
                if ($('.js-accordion-list').length > 0) {
                    $('.js-accordion-list').each(function () {
                        $(this).find('.js-accordion-list-item-body').hide();
                    });
                    $('.js-accordion-list .js-accordion-list-item-header').click(function (e) {
                        let $parentItem = $(this).parent('.js-accordion-list-item');
                        let $accordionList = $(this).closest('.js-accordion-list'); // Find the closest accordion container

                        $accordionList.find('.js-accordion-list-item')
                            .not($parentItem)
                            .removeClass('is--active')
                            .find('.js-accordion-list-item-body')
                            .slideUp();

                        if ($parentItem.hasClass('is--active')) {
                            $parentItem.removeClass('is--active').find('.js-accordion-list-item-body').slideUp();
                        } else {
                            $parentItem.addClass('is--active').find('.js-accordion-list-item-body').slideDown();
                        }

                        return false;
                    });
                }
                const $buttons = document.querySelectorAll(".collapse-header");
                if ($buttons.length === 0) return;
                Array.from($buttons).forEach(($button) => {
                    $button.addEventListener("click", (e) => {
                        e.preventDefault();
                        interactCollapses($button);
                    });
                });
                function interactCollapses(el) {
                    const $buttons = document.querySelectorAll(".collapse-header");
                    if (!el.classList.contains("active")) {
                        Array.from($buttons).forEach(($button) => {
                            $button.classList.remove("active");
                            $button.querySelector("span").classList.remove("open");
                        });
                        el.classList.add("active");
                        el.querySelector("span").classList.add("open");
                    } else {
                        el.classList.remove("active");
                        el.querySelector("span").classList.remove("open");
                    }
                }
            };
            collapses();
        }
        if (type != 'short') {
            if ($('.js-summary').length > 0) {
                $('.js-summary').click(function () {
                    var detailsBody = $(this).next('.js-details-body');
                    $(this).toggleClass("active");
                    detailsBody.slideToggle();
                });
            }
        }
        document.querySelectorAll('.js-product-card').forEach((card) => {
            if (!card.querySelector(".promo__applied")) {
                applyDiscountCodeMethod(card)
            }
        });
    }
}